import React from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import { useFormState } from "components/common";
import { SearchForm } from "./list-page";
import RecordingPaginatedTable from "./table";
import { parsePage } from "components/table";
import { parseQueryParams, handleChangeSearchFormField, handleClearSearchForm } from "components/common";

const RecordingListPage = ({ location: { search }, history }) => {
  const [state, dispatch] = useFormState({
    startDate: null,
    endDate: null,
    deploymentId: "",
    ...parseQueryParams(search),
  });

  return (
    <Dashboard>
      <PageHeaderBar title="app.page.recording.list" />
      <PageSection>
        <SearchForm
          onChange={handleChangeSearchFormField({ dispatch, search, history })}
          searchState={state}
          onClear={handleClearSearchForm({ dispatch, history })}
        />
      </PageSection>
      <PageSection hideBackground spaced>
        <RecordingPaginatedTable page={parsePage({ queryParams: search })} variables={state} />
      </PageSection>
    </Dashboard>
  );
};

export default RecordingListPage;
